import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'

import Error from './Error'
import Warning from './Warning'

const Catalog = {
  error: Error,
  warning: Warning
}

const Factory = ({ view }) => {
  const Component = Catalog[view]
  return Component ? <Component /> : null
}

class Modal extends Component {
  constructor() {
    super()
    this.el = document.createElement('div')
  }

  componentDidMount() {
    document.body.appendChild(this.el)
  }

  componentWillUnmount() {
    document.body.removeChild(this.el)
  }

  render() {
    const { modal } = this.props
    const { current } = modal

    const child = <Factory view={current} />

    return ReactDOM.createPortal(child, this.el)
  }
}

const mapState = state => {
  const { modal } = state
  return {
    modal
  }
}

export default connect(mapState)(Modal)



// WEBPACK FOOTER //
// ./src/components/Modal.js